import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationConfig } from '../beans/notification-config';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class NotificationConfigService {

	private readonly baseUrl = environment.serviceBaseUrl + '/api/notification-config';

	constructor(private http: HttpService) { }

	getAll(): Observable<NotificationConfig[]> {
		return this.http.get<NotificationConfig[]>(this.baseUrl);
	}

	save(config: NotificationConfig): Observable<NotificationConfig> {
		return this.http.post<NotificationConfig>(this.baseUrl, config);
	}
}
